/* eslint-disable */
import { useState, useEffect } from "react";
import { defineMessages, MessageDescriptor } from "react-intl";

const PREFIX = "NameValidator";
export const nameValidatorMessages = defineMessages({
  isRequired: {
    id: `${PREFIX}.isRequired`,
    defaultMessage: "The field is required",
  },
  mustMatch: {
    id: `${PREFIX}.mustMatch`,
    defaultMessage: "New password does not meet the specified requirements",
  },
  maxLength: {
    id: `${PREFIX}.checkCorrectness`,
    defaultMessage: "Please, check the length of the entered data",
  },
});

export const namePatt = /^(?:[A-Za-z0-9!#$%&"();:,<>@'*+\/\[\]\\=?^_`{|}~-]*)(?!.)/;
export const MAX_NAME_LENGTH = 50;
export const MAX_SURNAME_LENGTH = 100;

export type UseNameValidatorMode = "name" | "surname";

export function nameValidate(name: string | undefined | null, mode: UseNameValidatorMode = "name") {
  const errors: MessageDescriptor[] = [];
  if (name !== undefined && name !== null) {
    const maxLength = mode === "name" ? MAX_NAME_LENGTH : MAX_SURNAME_LENGTH;
    if (!name.length) {
      errors.push(nameValidatorMessages.isRequired);
    }
    if (!name.match(namePatt)) {
      errors.push(nameValidatorMessages.mustMatch);
    }
    if (name.length > maxLength) {
      errors.push(nameValidatorMessages.maxLength);
    }
  }
  return errors;
}

const initState = {
  valid: true,
  errors: [] as MessageDescriptor[],
};

export type UseNameValue = string | undefined | null;
export type UseNameValidatorResult = [boolean, MessageDescriptor[]];
export function useNameValidator(name: UseNameValue, mode: UseNameValidatorMode = "name"): UseNameValidatorResult {
  const [state, setState] = useState(initState);
  useEffect(() => {
    const errors = nameValidate(name, mode);
    setState({
      valid: !errors.length,
      errors,
    });
  }, [name]);
  return [state.valid, state.errors];
}
